module.exports = __webpack_public_path__ + "static/logo-32cf3907c03ef711db0ff91d9c6a3759.png";